import { loadStripe, type Stripe } from '@stripe/stripe-js';
import { useMemo } from 'react';

// Singleton promise for Stripe initialization
let stripePromise: Promise<Stripe | null> | null = null;

/**
 * Gets the Stripe publishable key from environment.
 */
function getStripePublishableKey(): string | undefined {
  return import.meta.env.VITE_STRIPE_PUBLIC_KEY;
}

/**
 * Initializes and returns the Stripe instance.
 * Uses singleton pattern to avoid multiple initializations.
 */
export function getStripePromise(): Promise<Stripe | null> {
  if (!stripePromise) {
    const publishableKey = getStripePublishableKey();
    if (!publishableKey) {
      console.warn('Stripe publishable key not configured');
      stripePromise = Promise.resolve(null);
    } else {
      stripePromise = loadStripe(publishableKey, {
        developerTools: {
          assistant: { enabled: false },
        },
      });
    }
  }
  return stripePromise;
}

/**
 * Hook for checking if Stripe is configured.
 */
export function useStripeConfigured(): boolean {
  return useMemo(() => !!getStripePublishableKey(), []);
}
